import { useState } from "react"
import logo from '../asset-1-1.webp'

export default function RegistrationForm() {
  const [attendees, setAttendees] = useState([
    { employeeName: "", department: "", attendeeEmail: "", attendeePhone: "" },
    { employeeName: "", department: "", attendeeEmail: "", attendeePhone: "" },
  ])

  const [formData, setFormData] = useState({
    pocPhone: "",
    pocEmail: "",
  })

  const [errors, setErrors] = useState({})

  const validate = () => {
    const newErrors = { attendees: [] }
    const phoneRegex = /^\d{8}$/
    // A more comprehensive list of free, personal, and disposable email domains.
    // For a production app, this list could be fetched from a server or a dedicated library.
    const personalEmailDomains = new Set([
        'gmail.com', 'yahoo.com', 'hotmail.com', 'aol.com', 'outlook.com', 'icloud.com', 'live.com', 'msn.com',
        'yandex.com', 'mail.com', 'gmx.com', 'protonmail.com', 'zoho.com', 'ymail.com', 'rocketmail.com',
        // Disposable email providers
        '10minutemail.com', 'temp-mail.org', 'guerrillamail.com', 'mailinator.com', 'throwawaymail.com'
    ]);

    // Validate Point of Contact
    if (!formData.pocPhone) {
      newErrors.pocPhone = "Phone number is required."
    } else if (!phoneRegex.test(formData.pocPhone)) {
        newErrors.pocPhone = "Phone number must be 8 digits."
    }

    if (!formData.pocEmail) {
      newErrors.pocEmail = "Work email is required."
    } else {
      const pocEmailParts = formData.pocEmail.split('@')
      if (pocEmailParts.length !== 2 || !pocEmailParts[1]) {
        newErrors.pocEmail = "Please enter a valid email address."
      } else {
        const pocEmailDomain = pocEmailParts[1].toLowerCase()
        if (personalEmailDomains.has(pocEmailDomain)) {
          newErrors.pocEmail = "Please use a work email, not a personal or disposable one."
        }
      }
    }

    // Validate Attendees
    attendees.forEach((attendee, index) => {
      const attendeeErrors = {}
      if (!attendee.employeeName) attendeeErrors.employeeName = "Employee name is required."
      if (!attendee.department) attendeeErrors.department = "Department is required."

      if (!attendee.attendeePhone) {
        attendeeErrors.attendeePhone = "Phone number is required."
      } else if (!phoneRegex.test(attendee.attendeePhone)) {
          attendeeErrors.attendeePhone = "Phone number must be 8 digits."
      }

      if (!attendee.attendeeEmail) {
        attendeeErrors.attendeeEmail = "Work email is required."
      } else {
        const attendeeEmailParts = attendee.attendeeEmail.split('@')
        if (attendeeEmailParts.length !== 2 || !attendeeEmailParts[1]) {
          attendeeErrors.attendeeEmail = "Please enter a valid email address."
        } else {
          const attendeeEmailDomain = attendeeEmailParts[1].toLowerCase()
          if (personalEmailDomains.has(attendeeEmailDomain)) {
            attendeeErrors.attendeeEmail = "Please use a work email, not a personal or disposable one."
          }
        }
      }
      if (Object.keys(attendeeErrors).length > 0) {
        newErrors.attendees[index] = attendeeErrors
      }
    })

    setErrors(newErrors)
    return Object.keys(newErrors).length === 1 && newErrors.attendees.length === 0
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    if (validate()) {
      console.log("Form submitted:", { ...formData, attendees })
      alert("Form submitted successfully!")
    }
  }

  const handleChange = (field) => (e) => {
    const { value } = e.target
    if (field === 'pocPhone') {
      if (/^\d*$/.test(value)) {
        setFormData((prev) => ({ ...prev, [field]: value }))
      }
    } else {
      setFormData((prev) => ({ ...prev, [field]: value }))
    }
  }

  const handleAttendeeChange = (index, field) => (e) => {
    const newAttendees = [...attendees]
    const { value } = e.target
    if (field === 'attendeePhone') {
      if (/^\d*$/.test(value)) {
        newAttendees[index][field] = value
        setAttendees(newAttendees)
      }
    } else {
      newAttendees[index][field] = value
      setAttendees(newAttendees)
    }
  }

  const addAttendee = () => {
    if (attendees.length < 3) {
      setAttendees([...attendees, { employeeName: "", department: "", attendeeEmail: "", attendeePhone: "" }])
    }
  }

  const removeAttendee = (index) => {
    const newAttendees = attendees.filter((_, i) => i !== index)
    setAttendees(newAttendees)
  }

  return (
    <div className="registration-container">
      <div className="registration-header">
        <div className="logo-circle">
          {/* <FileText className="logo-icon" /> */}
          <img src={logo} alt="logo" style={{maxWidth: '75%'}}/>
        </div>
        <h1 className="header-title">Registration Form For Crash Course</h1>
      </div>

      <form onSubmit={handleSubmit} className="registration-form">
        <div className="form-section">
          <h2 className="section-title">Point of Contact</h2>

          <div className="form-grid">
            <div className="form-field">
              <label htmlFor="pocPhone" className="field-label">
                Phone Number
              </label>
              <input
                id="pocPhone"
                type="tel"
                placeholder="98765432"
                value={formData.pocPhone}
                onChange={handleChange("pocPhone")}
                className="form-input"
                required
              />
              {errors.pocPhone && <p className="error-text">{errors.pocPhone}</p>}
            </div>

            <div className="form-field">
              <label htmlFor="pocEmail" className="field-label">
                Work Email
              </label>
              <input
                id="pocEmail"
                type="email"
                placeholder="contact@company.com"
                value={formData.pocEmail}
                onChange={handleChange("pocEmail")}
                className="form-input"
                required
              />
              {errors.pocEmail && <p className="error-text">{errors.pocEmail}</p>}
            </div>
          </div>

          <div className="info-note">
            <p className="note-text">This email entered is used for verification for attendees registration</p>
          </div>
        </div>

        <div className="attendees-section">
          <div className="attendees-header">
            <h2 className="section-title" style={{border: 'none', paddingBottom: '0'}}>Attendees Registration</h2>
          </div>

          {attendees.map((attendee, index) => (
            <div key={index} className="attendee-card">
              <div className="attendee-card-header">
                <h3 className="attendee-title">Attendee {index + 1}</h3>
                {attendees.length === 3 && (
                  <button type="button" onClick={() => removeAttendee(index)} className="remove-btn">
                    Remove
                  </button>
                )}
              </div>

              <div className="form-grid">
                <div className="form-field">
                  <label htmlFor={`employeeName-${index}`} className="field-label">
                    Employee Name
                  </label>
                  <input
                    id={`employeeName-${index}`}
                    type="text"
                    placeholder="John Doe"
                    value={attendee.employeeName}
                    onChange={handleAttendeeChange(index, "employeeName")}
                    className="form-input"
                    required
                  />
                  {errors.attendees?.[index]?.employeeName && <p className="error-text">{errors.attendees[index].employeeName}</p>}
                </div>

                <div className="form-field">
                  <label htmlFor={`department-${index}`} className="field-label">
                    Department
                  </label>
                  <input
                    id={`department-${index}`}
                    type="text"
                    placeholder="Engineering"
                    value={attendee.department}
                    onChange={handleAttendeeChange(index, "department")}
                    className="form-input"
                    required
                  />
                  {errors.attendees?.[index]?.department && <p className="error-text">{errors.attendees[index].department}</p>}
                </div>

                <div className="form-field">
                  <label htmlFor={`attendeeEmail-${index}`} className="field-label">
                    Work Email
                  </label>
                  <input
                    id={`attendeeEmail-${index}`}
                    type="email"
                    placeholder="employee@company.com"
                    value={attendee.attendeeEmail}
                    onChange={handleAttendeeChange(index, "attendeeEmail")}
                    className="form-input"
                    required
                  />
                  {errors.attendees?.[index]?.attendeeEmail && <p className="error-text">{errors.attendees[index].attendeeEmail}</p>}
                </div>

                <div className="form-field">
                  <label htmlFor={`attendeePhone-${index}`} className="field-label">
                    Phone Number
                  </label>
                  <input
                    id={`attendeePhone-${index}`}
                    type="tel"
                    placeholder="98765432"
                    value={attendee.attendeePhone}
                    onChange={handleAttendeeChange(index, "attendeePhone")}
                    className="form-input"
                    required
                  />
                  {errors.attendees?.[index]?.attendeePhone && <p className="error-text">{errors.attendees[index].attendeePhone}</p>}
                </div>
              </div>
            </div>
          ))}
        </div>

        {attendees.length < 3 && (
              <button type="button" onClick={addAttendee} className="add-attendee-btn">
                + Add Attendee
              </button>
            )}

        <button type="submit" className="submit-btn">
          Submit Registration
        </button>
      </form>
    </div>
  )
}
